module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_inside_01.3a65d6ea.png";